// extracted by mini-css-extract-plugin
export var actions = "_n2-5";
export var assistantBubble = "_n2-3";
export var assistantRow = "_n2-6";
export var bubble = "_n2-0";
export var humanAvatar = "_n2-4";
export var inlineToolCard = "_n2-1";
export var userBubble = "_n2-2";